import React, { useState, useEffect, useContext  } from "react";
import { Container } from 'react-bootstrap';
import { useParams } from "react-router-dom";  // Import Link from react-router-dom
import { AuthContext } from "../../AuthContext";
import "./UserDashboard.css"
import Sidebar from "../UserDashSidebar/UserDashSidebar";
import DashboardOverview from "../DashboardOverview/DashboardOverview";
import FavoriteAds from "../FavoriteAds/FavoriteAds";
import UnansweredQuestions from "../UnansweredQuestions/UnansweredQuestions";
import ProfileSettings from "../ProfileSettings/ProfileSettings";
import PrivacySettings from "../PrivacySettings/PrivacySettings";
import Faq from "../Faq/Faq";

const UserDashboard = () => {
  const { tab } = useParams();
  const [activeTab, setActiveTab] = useState("dashboard");
  const { logoutUser } = useContext(AuthContext);

  useEffect(() => {
    setActiveTab(tab || "dashboard");
  }, [tab]);

  const renderContent = () => {
    switch (activeTab) {
      case "nadzorna-plosca":
        return <DashboardOverview />;
      case "priljubljeni-oglasi":
        return <FavoriteAds />;
      case "neodgovorjena-vprasanja":
        return <UnansweredQuestions />;
      case "nastavitve-profila":
        return <ProfileSettings />;
      case "nastavitve-zasebnosti":
        return <PrivacySettings onLogout={logoutUser} />;
      case "faq":
        return <Faq />;
      default:
        return <h1>Unknown Tab</h1>;
    }
  };

  return (
    <div className="dahboard_bg">
      <Container className="dashboard-container">
        <div className="row">
          <div className="col-lg-3">
            <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} onLogout={logoutUser} />
          </div>
          <div className="col-lg-9">
            {renderContent()}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default UserDashboard;